import FlexBox from './flex-box.component';

export default FlexBox;
